/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { FAQEntity } from '../model/fAQEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { baseUrl } from '../../../environments/environment.prod';
import { LoginRenderingService } from 'src/app/services/login/login-rendering.service';

@Injectable()
export class FaqControllerService {

    baseFaqUrl = baseUrl + `master/`;

    protected basePath = this.baseFaqUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient,
         @Optional() @Inject(BASE_PATH) basePath: string,
     @Optional() configuration: Configuration, 
     private loginRenderingService: LoginRenderingService) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addFAQ
     * 
     * @param fAQEntity FAQEntity
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addFAQUsingPOST(fAQEntity: Array<FAQEntity>, observe?: 'body', reportProgress?: boolean): Observable<Array<FAQEntity>>;
    public addFAQUsingPOST(fAQEntity: Array<FAQEntity>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FAQEntity>>>;
    public addFAQUsingPOST(fAQEntity: Array<FAQEntity>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FAQEntity>>>;
    public addFAQUsingPOST(fAQEntity: Array<FAQEntity>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
       
        let currentUser=this.loginRenderingService.currentUser;

       
        if (fAQEntity === null || fAQEntity === undefined) {
            throw new Error('Required parameter fAQEntity was null or undefined when calling addFAQUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required


        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
            headers = headers.append('X-AUTH-TOKEN', `Bearer ${currentUser.token}`);
        }

        return this.httpClient.post<Array<FAQEntity>>(`${this.basePath}faq/addFAQ`,
            fAQEntity,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteFAQ
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFAQUsingDELETE(id: string, observe?: 'body', reportProgress?: boolean): Observable<FAQEntity>;
    public deleteFAQUsingDELETE(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQEntity>>;
    public deleteFAQUsingDELETE(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQEntity>>;
    public deleteFAQUsingDELETE(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      
        let currentUser=this.loginRenderingService.currentUser;

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteFAQUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required


        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
            headers = headers.append('X-AUTH-TOKEN', `Bearer ${currentUser.token}`);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<FAQEntity>(`${this.basePath}faq/deleteFAQ/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * editFAQ
     * 
     * @param faqEntity faqEntity
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editFAQUsingPOST(faqEntity: FAQEntity, observe?: 'body', reportProgress?: boolean): Observable<FAQEntity>;
    public editFAQUsingPOST(faqEntity: FAQEntity, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FAQEntity>>;
    public editFAQUsingPOST(faqEntity: FAQEntity, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FAQEntity>>;
    public editFAQUsingPOST(faqEntity: FAQEntity, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
        let currentUser=this.loginRenderingService.currentUser;

        if (faqEntity === null || faqEntity === undefined) {
            throw new Error('Required parameter faqEntity was null or undefined when calling editFAQUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required


        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
            headers = headers.append('X-AUTH-TOKEN', `Bearer ${currentUser.token}`);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FAQEntity>(`${this.basePath}faq/editFAQ`,
            faqEntity,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchAdminFAq
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchAdminFAqUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<FAQEntity>>;
    public fetchAdminFAqUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FAQEntity>>>;
    public fetchAdminFAqUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FAQEntity>>>;
    public fetchAdminFAqUsingGET(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
       
        let currentUser=this.loginRenderingService.currentUser;

        let headers = this.defaultHeaders;

        // authentication (Bearer) required


        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
            headers = headers.append('X-AUTH-TOKEN', `Bearer ${currentUser.token}`);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<FAQEntity>>(`${this.basePath}faq/fetchAdminFAq`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * fetchFAQ
     * 
     * @param appList appList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchFAQUsingPOST(appList: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<FAQEntity>>;
    public fetchFAQUsingPOST(appList: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FAQEntity>>>;
    public fetchFAQUsingPOST(appList: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FAQEntity>>>;
    public fetchFAQUsingPOST(appList: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      
        let currentUser=this.loginRenderingService.currentUser;

        if (appList === null || appList === undefined) {
            throw new Error('Required parameter appList was null or undefined when calling fetchFAQUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required


        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
            headers = headers.append('X-AUTH-TOKEN', `Bearer ${currentUser.token}`);
        }

        return this.httpClient.post<Array<FAQEntity>>(`${this.basePath}faq/fetchFAQ`,
            appList,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
